import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {VboEvents} from "./types/vbo-events";
import {VboEventsComponent as BaseVboEventsComponent} from "../../../vbo-events/vbo-events.component";

@Component({
  selector: 'app-widget-vbo-events',
  standalone: true,
  imports: [CommonModule, BaseVboEventsComponent],
  templateUrl: './vbo-events.component.html',
  styleUrls: ['./vbo-events.component.less']
})
export class VboEventsWidgetComponent {
  @Input() widget!: VboEvents;
}
